import NextLink from 'next/link'
import { cond, get } from 'lodash-es'
import styled from '@emotion/styled'

const Link = styled(NextLink)`
  height: initial;
  border: none;
  text-decoration: none;
  &:focus {
    text-decoration: none;
  }

  ${({ theme, $origin, $textSecondary, $error, $nowrap, $color, href }) => `
    color: ${cond([
      [(props) => props.$error, () => theme.palette.error.main],
      [(props) => props.$origin, () => theme.palette.text.primary],
      [(props) => props.$textSecondary, () => theme.palette.text.secondary],
      [(props) => !!props.$color, () => get(theme.palette, $color)],
      [() => true, () => theme.palette.primary.main],
    ])({ $origin, $textSecondary, $error, $color })};
    white-space: ${$nowrap ? 'nowrap' : 'normal'};
    cursor: ${href !== '' ? 'pointer' : 'default'};

    &:hover {
      color: ${cond([
        [(props) => props.$error, () => theme.palette.error.main],
        [(props) => props.$origin, () => theme.palette.text.primary],
        [(props) => props.$textSecondary, () => theme.palette.text.secondary],
        [(props) => !!props.$color, () => get(theme.palette, $color)],
        [() => true, () => theme.palette.primary.main],
      ])({ $origin, $textSecondary, $error, $color })};
    }
  `}
`

export default Link
